import {BaseComponents} from '../../shared/base-components';
import {HostListener, Injector} from '@angular/core';
import {CupomService} from '../../core/services/cupom.service';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {CepService} from '../../core/services/cep.service';
import {AppComponent} from '../../app.component';
import {Meta, Title} from '@angular/platform-browser';
import {ProdutoService} from '../../core/services/produto.service';
import {ItemProposta, Proposta} from '../../core/viewModel/proposta.model';
import {ICarrinho} from '../../shared/interfaces/carrinho.interface';
import {Planos} from '../../core/viewModel/planos.model';
import {
    BASICO,
    BASICO_TRIPLO, BLACK, BLACK_TRIPLO,
    COMPLETO,
    COMPLETO_TRIPLO,
    COUNT_DIARIAS_DEFAULT, EXCLUSIVO, EXCLUSIVO_TRIPLO, HOME, ID_PRICE_BOOK,
    IDEAL,
    IDEAL_TRIPLO, PAGINA_PAGAMENTO, PLUS, PLUS_TRIPLO, REQUINTE, REQUINTE_TRIPLO
} from '../../app.constants';
import {AssinaturaService} from '../../core/services/assinatura.service';
import {DeviceDetectorService} from 'ngx-device-detector';

export class PropostaComponent extends BaseComponents {

    protected cupomService: CupomService;
    protected router: Router;
    protected toast: ToastrService;
    protected cepService: CepService;
    protected appComponent: AppComponent;
    protected produtoService: ProdutoService;
    protected assinaturaService: AssinaturaService;
    protected meta: Meta;
    protected deviceService: DeviceDetectorService;
    public minDailyCoupon = 10;
    public couponMessage: string;

    protected constructor(protected injector: Injector) {
        super(injector);
        this.cupomService = injector.get(CupomService);
        this.router = injector.get(Router);
        this.toast = injector.get(ToastrService);
        this.cepService = injector.get(CepService);
        this.appComponent = injector.get(AppComponent);
        this.titleService = injector.get(Title);
        this.produtoService = injector.get(ProdutoService);
        this.assinaturaService = injector.get(AssinaturaService);
        this.meta = injector.get(Meta);
        this.deviceService = injector.get(DeviceDetectorService);
    }

    public proposta: Proposta;
    public propostaResult: Proposta;
    public propostaStorage: Proposta;
    public carrinhos: ICarrinho[];
    public planos: Planos[] = [];
    public planosAll: Planos[] = [];
    public planosDuplos: Planos[] = [];
    public planosTriplos: Planos[] = [];
    public plano: Planos;

    public UserCPF: any;
    public UserEMAIL: any;
    public valorMensal: any;
    public selectedCategoria: any;
    public params: any;
    public categoriaTitulo: any;

    public text1: string;
    public text2: string;

    public showMaisPlanos = true;
    public fidelizacaoCliente = true;

    public totalDiarias = 0;
    public countDiarias = 7;
    public totalDuplos: 0;
    public totalTriplos: 0;
    public selectedTypeValue = 2;
    public isCupomValido = false;
    public cupom = '';
    public emailCliente = '';
    public cpfCliente = '';
    public iframeSrc = '';
    public cupomSales = null;
    public typeValues = [{value: 2, label: 'Duplo'}, {value: 3, label: 'Triplo'}];
    public mensagemCupom: string = null;
    public idPriceBook = ID_PRICE_BOOK;

    public minDiaria: number = COUNT_DIARIAS_DEFAULT;
    public paginaPagamento = PAGINA_PAGAMENTO;

    queryPlano: any;
    queryQuarto: any;
    queryDiarias: any;
    selectedCategoriaQuery: any;

    isQueryParams = false;
    deviceInfo = null;
    os = null;
    device = null;
    path = '/';

    @HostListener('window:resize', ['$event'])
    onResize($event: Event) {
        this.handleMobile();
    }

    public checkDevice(url: string = '') {
        this.deviceInfo = this.deviceService.getDeviceInfo();
        this.isMobile = this.deviceService.isMobile();
        const { os = '' , device = ''} = this.deviceInfo;
        this.os = os;
        this.device = device;
        this.path = `/${url}`;
        this.isIphone = this.device === 'iPhone' && this.os === 'iOS';
    }

    public redirectUrl(url: string) {
        const mobile = this.isIphone;
        let newUrl = url;
        switch (url) {
            case '/faca-parte':
                if (mobile) {
                    newUrl = '/faca-parte-mobile';
                }
                break;
            case '/faca-parte-mobile':
                if (!mobile) {
                    newUrl = '/faca-parte';
                }
                break;
            case '/exclusividade':
                if (mobile) {
                    newUrl = '/faca-parte-mobile';
                }
                break;
            case '/exclusividade-mobile':
                if (!mobile) {
                    newUrl = '/faca-parte';
                }
                break;
            default:
                newUrl = url;
                break;
        }
        return newUrl;
    }

    public isUrlMobile(url: string): boolean {
        switch (url) {
            case '/faca-parte':
                return false;
            case '/faca-parte-mobile':
                return true;
            case '/exclusividade':
                return false;
            case '/exclusividade-mobile':
                return true;
            default:
                return false;
        }
    }

    async inOnInit(carregarDados: boolean = true) {
        const {notAvailable, message, title} = this.isMaintenance();
        if (notAvailable) {
            this.toast.error(message, title, { timeOut: 5000});
            await this.router.navigate(['/']);
            return;
        }
        super.ngOnInit();
        this.setUtmParams();
        this.queryParams();
        if (carregarDados) {
            await this.carregarDados();
        }
    }

    queryParams() {
        this.isQueryParams = false;
        if (this.params) {
            const { diarias = '', plano = '', quarto = ''} = this.params;
            this.queryDiarias = diarias !== '' ? diarias : undefined;
            this.queryPlano = plano !== '' ? plano : undefined;
            this.queryQuarto = quarto !== '' ? quarto : undefined;
            if (this.queryDiarias || this.queryPlano || this.queryQuarto) {
                this.isQueryParams = true;
            }

        }
    }
    setUtmParams() {
        if (this.params) {
            const utmParams = {
                utm_campaign: (this.params.utm_campaign) ? this.params.utm_campaign : '',
                utm_medium: (this.params.utm_medium) ? this.params.utm_medium : '',
                utm_source: (this.params.utm_source) ? this.params.utm_source : '',
                utm_term: (this.params.utm_term) ? this.params.utm_term : '',
            };
            localStorage.setItem('mtl.utm', JSON.stringify(utmParams));
        }
    }


    async carregarDados() {
        this.appComponent.showOverlay();
        const proposta = await this.loadProposta();
        await this.setProposta(proposta);
        await this.validaCupom();
        this.appComponent.hideOverlay();
    }

    async loadProposta() {
        if (this.isQueryParams) {
            return await this.carregarDadosPropostaPadraoFacilita();
        }
        if (this.isDefault()) {
            return await this.carregarDadosPropostaPadraoFacilita();
        }
        const storage = this.getPropostaParaStorage();
        if (!storage) {
            return await this.carregarDadosPropostaPadraoFacilita();
        }
        const items = storage.itensProposta;

        const lessThanMinDaily = items.filter((item: { diarias: number; }) => item.diarias < this.minDiaria);

        if(lessThanMinDaily.length > 0) {
            return await this.carregarDadosPropostaPadraoFacilita();
        }
        return storage;
    }
    isDefault() {
        return !this.storageValido() && !this.isQueryParams;
    }

// TODO BEGIN STORAGE
    storageValido() {
        const storage = this.getPropostaParaStorage();
        return !!(
            storage &&
            storage.itensProposta.length &&
            storage.itensProposta[0].diarias &&
            storage.itensProposta[0].pessoas &&
            storage.itensProposta[0].quartos
        );
    }
    setCupomStorage(obj) {
        localStorage.setItem('montreal.cliente_cupom', JSON.stringify(obj));
    }
    getCupomStorage() {
        return JSON.parse(localStorage.getItem('montreal.cliente_cupom'));
    }
    removeCupomStorage() {
        localStorage.removeItem('montreal.cliente_cupom');
    }
    getPropostaParaStorage() {
        return JSON.parse(localStorage.getItem('mtl.proposta'));
    }
    storeClient(obj) {
        localStorage.setItem('montreal.cliente', JSON.stringify(obj));
    }

    getClient() {
        return JSON.parse(localStorage.getItem('montreal.cliente'));
    }
    armazenarClienteCpf(obj) {
        localStorage.setItem('montreal.cliente_cpf', JSON.stringify(obj));
    }
    armazenarClienteEmail(obj) {
        localStorage.setItem('montreal.cliente_email', JSON.stringify(obj));
    }
    getTokenUsuario() {
        return localStorage.getItem('montreal.cliente.token');
    }
    getClienteCpf() {
        return JSON.parse(localStorage.getItem('montreal.cliente_cpf'));
    }
// TODO END STORAGE

// TODO BEGIN PLANOS
    async getPlanos() {
        const data = await this.produtoService.planos();
        this.planosDuplos = !data ? [] : this.produtoService.onlyDoubles(data, this.minDiaria);
        this.planosTriplos = !data ? [] : this.produtoService.onlyTriples(data, this.minDiaria);
        this.selectedCategoria = !data ? '08' : this.planosDuplos[0].codigoCategoria;
        this.planosAll = this.planosDuplos.concat(this.planosTriplos);
        this.planos = this.planosAll;
    }
    getPlanoQuery() {
        let planos = this.planosDuplos;
        let plano = this.planosDuplos[1] || null;
        let qtdDiariaPlano = !plano ? null : plano.qtdDiarias.filter(item => item.quantidadeDiarias === this.countDiarias)[0];
        let isDuplo = true;
        if (this.queryQuarto) {
            if (this.queryQuarto.toUpperCase() === 'TRIPLO') {
                planos = this.planosTriplos;
                this.selectedCategoria = this.produtoService.transitionType(this.selectedCategoria);
                this.selectedTypeValue = 3;
                isDuplo = false;
            }
        }
        if (this.selectedCategoriaQuery) {
            if (!isDuplo) {
                this.selectedCategoriaQuery = this.produtoService.transitionType(this.selectedCategoriaQuery);
            }
            const data = planos.filter(item => item.codigoCategoria === this.selectedCategoriaQuery);
            if (data) {
                plano = data[0];
            }
        }
        if (this.queryDiarias) {
            if (this.queryDiarias >= 4 && this.queryDiarias <= 28) {
                const diariaPlano = plano.qtdDiarias.filter(item => +item.quantidadeDiarias === +this.queryDiarias) || [];
                qtdDiariaPlano = (diariaPlano.length) ? diariaPlano[0] : qtdDiariaPlano;
            }
        }
        return { plano, qtdDiariaPlano, pessoas: isDuplo ? 2 : 3 };
    }
    private countTriplosDuplos(itensProposta: ItemProposta[]) {
        this.totalDuplos = 0;
        this.totalTriplos = 0;
        itensProposta.forEach(itens => {
            if (itens.pessoas === 2) {
                this.totalDuplos++;
            }
            if (itens.pessoas === 3) {
                this.totalTriplos++;
            }
        });

    }
// TODO END PLANOS

// TODO BEGIN CALCULOS
    getItensProposta() {
        return this.carrinhos.map(value => {
            return this.planos
                .filter(item => item.codigoCategoria === value.selectedCategoria)
                .map(item => {
                    const diarias = +value.countDiarias;
                    const qtdDiaria = item.qtdDiarias.filter(qtd => qtd.quantidadeDiarias === diarias)[0];
                    let categoriaTitulo = this.setToUpperCase(item.descricao);
                    categoriaTitulo = categoriaTitulo.replace('TRIPLO', '').trim();
                    return {
                        codigoCategoriaSales: item.codigoCategoriaSales,
                        categoriaTitulo,
                        diarias,
                        pessoas: value.selectedTypeValue,
                        quartos: 1,
                        valor: qtdDiaria.valor,
                        valoresTitulosDetalhado: [{
                            codigoCategoria: item.codigoCategoria,
                            categoriaDescricao: categoriaTitulo,
                            quantidadeDiarias: diarias,
                            qtdTitulos: 1,
                            descricao: qtdDiaria.descricao,
                            valor: qtdDiaria.valor,
                        }]
                    };
                });
        })[0];
    }
    getTotalMensalidade(itensProposta: Array<any> | any) {
        const isItensProposta = !itensProposta ? false : itensProposta.length > 0;

        const valor = isItensProposta ? itensProposta.map(item => item.valor).reduce((total, item) => total + item) : 0;
        const valorMensalidade = this.transformMoney(valor);
        return {valor, valorMensalidade};
    }
    calcularTotalDiarias() {
        let totalDiarias = 0;
        this.carrinhos.map(item => totalDiarias += item.countDiarias);
        this.totalDiarias = totalDiarias;
        if (this.totalDiarias >= 28) {
            this.zerarBotaoAdicionar();
            return;
        }
        this.showMaisPlanos = true;
    }
    async calcularValoresFacilita() {
        this.calcularTotalDiarias();
        if (this.totalDiarias > 28 && this.isMobile) {
            this.toast.error('o Número total de diárias não pode ultrapassar 28 diárias.', '', {
                timeOut: 5000
            });
            return;
        }
        const itensProposta = this.getItensProposta();
        const { valorMensalidade } = this.getTotalMensalidade(itensProposta);
        const valorMensalidadeDesconto = this.isCupomValido ? this.calcularDesconto(valorMensalidade) : '0.00';
        const proposta = this.getPropostaParaStorage();
        proposta.cupomAceito = this.isCupomValido;
        proposta.cupomId = this.isCupomValido ? this.cupomSales.id : null;
        proposta.valorMensalidade = valorMensalidade;
        proposta.valorMensalidadeDesconto = this.transformMoney(valorMensalidadeDesconto);
        proposta.itensProposta = itensProposta;
        proposta.valorAdesaoDesconto = 'R$ 0,00';
        this.proposta = proposta;
        this.propostaResult = this.mountProposta();
        this.carrinhos = this.transformResultInCarrinho(itensProposta);
        this.calcularTitulos();
        this.addPropostaParaStorage(proposta);
        this.appComponent.hideOverlay();
    }
    calcularTitulos() {
        this.changeTitulo(BASICO, BASICO_TRIPLO);
        this.changeTitulo(COMPLETO, COMPLETO_TRIPLO);
        this.changeTitulo(IDEAL, IDEAL_TRIPLO);
        this.changeTitulo(EXCLUSIVO, EXCLUSIVO_TRIPLO);
        this.changeTitulo(REQUINTE, REQUINTE_TRIPLO);
        this.changeTitulo(PLUS, PLUS_TRIPLO);
        this.changeTitulo(BLACK, BLACK_TRIPLO);
        const last = this.carrinhos.length ? this.carrinhos[this.carrinhos.length - 1].id : 0;
        this.carrinhos.forEach( carrinho => {
            if (carrinho.id === last) {
                carrinho.last = true;
            }
        });
    }
    changeTitulo(duplo: string, triplo: string) {
        const carrinhos = this.carrinhos;
        const data = [];
        let tituloTotalPessoas = 0;
        let tituloTotalValorMensal = 0;
        let tituloTotalValorMensalString = '';
        let tituloTotalDiaria = 0;
        carrinhos.forEach(carrinho => {
            if (carrinho.selectedCategoria === duplo || carrinho.selectedCategoria === triplo) {
                carrinho.last = false;
                tituloTotalPessoas = tituloTotalPessoas + carrinho.selectedTypeValue;
                tituloTotalValorMensal = tituloTotalValorMensal + this.convertStringToFloat(carrinho.valorMensalString);
                tituloTotalDiaria = tituloTotalDiaria + carrinho.countDiarias;
                data.push(carrinho);
            }
        });
        if (data.length > 0) {
            tituloTotalValorMensal = +parseFloat(String(tituloTotalValorMensal)).toFixed(2);
            tituloTotalValorMensalString = `R$ ${tituloTotalValorMensal}`;
            tituloTotalValorMensalString = tituloTotalValorMensalString.replace('.', ',');
            const last = data[data.length - 1].id;
            data.forEach( item => {
                if (item.id === last) {
                    const text = this.setText(
                        item.selectedCategoria,
                        tituloTotalValorMensalString,
                        tituloTotalPessoas.toString(),
                        tituloTotalDiaria
                    );
                    item.text1 = text.text1;
                    item.text2 = text.text2;
                    item.last = true;
                } else {
                    item.text1 = '';
                    item.text2 = '';
                }
                this.carrinhos.map(carrinho => {
                    if (carrinho.id === item.id) {
                        item.last = false;
                        carrinho = item;
                    }
                });
            });
        }
    }
    convertStringToFloat(value: string): number {
        const valueReplace = value.replace('R$', '').replace(',', '.').trim();
        return +parseFloat(valueReplace).toFixed(2);
    }
    setText(codigoCategoria: string, valor: string, totalPessoa: string, countDiarias: number) {
        const text1 = this.produtoService.getText(0, codigoCategoria, valor);
        let text2 = this.produtoService.getText(2, codigoCategoria, valor);
        text2 = text2.replace('de 7 diárias', 'a partir de ' + countDiarias + ' diárias');
        text2 = text2.replace('duas pessoas.', totalPessoa + ' pessoas.');
        return { text1, text2};
    }
    calcularDesconto(money) {
        const { valueDiscount } = this.cupomSales;
        const originalPrice = this.getOriginalPrice(money);
        const discount = valueDiscount > 0 ? +(originalPrice * valueDiscount) : originalPrice;
        const result = originalPrice - discount;
        return parseFloat(String(result)).toFixed(2);
    }
    transformMoney(value) {
        return `R$ ${String(value).replace('.', ',')}`;
    }
    getOriginalPrice(money) {
        if (typeof  money === 'string') {
            let originalPrice = null;
            originalPrice = money.split('R$');
            originalPrice = originalPrice[1];
            return +originalPrice.replaceAll(',', '.');
        }
        return money;
    }
// TODO END CALCULOS

// TODO BEGIN PROPOSTA
    async carregarDadosPropostaPadraoFacilita() {
        await this.getPlanos();
        const { plano, qtdDiariaPlano,  pessoas } = this.getPlanoQuery();
        const descricao = qtdDiariaPlano ? qtdDiariaPlano.descricao : 'R$ 0';
        const planoDescricao = plano ? plano.descricao : '';
        const planoCodigoCategoriaSales = plano ? plano.codigoCategoriaSales : '';
        const planoCodigoCategoria = plano ? plano.codigoCategoria : '';
        const quantidadeDiarias = qtdDiariaPlano ? qtdDiariaPlano.quantidadeDiarias : 0;
        return {
            cupom:  '',
            cupomAceito: false,
            mensagemCupom: '',
            cupomId: null,
            fidelizacaoCliente: this.fidelizacaoCliente,
            msgError: null,
            msgLimite: null,
            qtdPessoa: null,
            quartoDuplo: 0,
            quartoTriplo: 1,
            quartosPossiveis: null,
            valorAdesao: 'R$ 0,00',
            valorAdesaoDesconto: 'R$ 0,00',
            valorMensalidade: this.produtoService.monthlyValueString(descricao),
            valorMensalidadeDesconto: 'R$ 0,00',
            itensProposta: [
                {
                    categoriaTitulo: planoDescricao,
                    codigoCategoria: planoCodigoCategoria,
                    diarias: quantidadeDiarias,
                    pessoas,
                    quartos: 1,
                    valor: qtdDiariaPlano ? qtdDiariaPlano.valor : 0,
                    codigoCategoriaSales: planoCodigoCategoriaSales,
                    valoresTitulosDetalhado: [
                        {
                            categoriaDescricao: planoDescricao,
                            codigoCategoria: planoCodigoCategoria,
                            descricao: descricao,
                            qtdTitulos: 1,
                            quantidadeDiarias: quantidadeDiarias,
                            codigoCategoriaSales: planoCodigoCategoriaSales,
                        }
                    ]
                }
            ],
        };
    }
    async setProposta(proposta) {
        this.carrinhos = this.transformResultInCarrinho(proposta.itensProposta);
        this.propostaStorage = proposta;
        await this.getPlanos();
        this.cupom = proposta.cupomAceito && proposta.cupom ? proposta.cupom : '';
        if (proposta && proposta.email) {
            this.emailCliente = proposta.email;
        }
        this.addPropostaParaStorage(this.propostaStorage);
    }
    addPropostaParaStorage(obj) {
        let objParaSalvar = obj;
        const proposta = this.getPropostaParaStorage();
        if (proposta) {
            objParaSalvar = { ...proposta, ...objParaSalvar };
        }
        localStorage.setItem('mtl.proposta', JSON.stringify(objParaSalvar));
    }
    mountProposta(): Proposta {
        this.categoriaTitulo = '';
        if(this.proposta.itensProposta) {
            this.countTriplosDuplos(this.proposta.itensProposta);
        }
        this.valorMensal = this.proposta.valorMensalidade;
        this.countDiarias = this.totalDiarias;
        return {
            cupom: (this.isCupomValido) ? this.cupom : '',
            cupomId: (this.isCupomValido) ? this.cupomSales.id : null,
            cupomAceito: this.isCupomValido,
            itensProposta: this.proposta.itensProposta,
            mensagemCupom: this.proposta.mensagemCupom,
            fidelizacaoCliente: this.fidelizacaoCliente,
            msgError: this.proposta.msgError,
            msgLimite: this.proposta.msgLimite,
            qtdPessoa: this.proposta.qtdPessoa,
            quartoDuplo: this.totalDuplos,
            quartoTriplo: this.totalTriplos,
            quartosPossiveis: this.proposta.quartosPossiveis,
            valorAdesao: this.proposta.valorAdesao,
            valorAdesaoDesconto: this.proposta.valorAdesaoDesconto,
            valorMensalidade: this.proposta.valorMensalidade,
            valorMensalidadeDesconto: this.proposta.valorMensalidadeDesconto
        };
    }

    async responseClientValidate(value, type) {
        switch (type) {
            case 'CPF':
                return await this.assinaturaService.validaCpf(value);
            case 'EMAIL':
                return  await this.assinaturaService.validaEmail(value);
            default:
                return  { data: null, status: 500 };
        }
    }
    async goToPersonalDataPage(type, data, value) {
        switch (type) {
            case 'CPF':
                this.UserCPF = data;
                this.cpfCliente = value;
                this.armazenarClienteCpf(this.UserCPF);
                break;
            case 'EMAIL':
                this.UserEMAIL = data;
                this.armazenarClienteEmail(this.UserEMAIL);
                this.emailCliente = value;
                this.addPropostaParaStorage({email: this.emailCliente});
                if (this.isIphone) {
                    await this.router.navigate(['dados-pessoais']);
                    return;
                }
                window.location.href = `${HOME}/dados-pessoais`;
                break;
            default:
                this.toast.error('Tipo invalido!');
                break;
        }
    }

    async clientValidate(value, type) {
        const result = await this.responseClientValidate(value, type);
        const { data, status} = result;
        switch (status) {
            case 404:
                await this.goToPersonalDataPage(type, data, value);
                break;
            case 200:
                if (data.Type === 'Cliente') {
                    await this.router.navigate([`clients-sales`], {queryParams: {name: data.Name || 'Cliente'}});
                    break;
                }
                await this.goToPersonalDataPage(type, data, value);
                break;
            default:
                this.toast.error('Falha na requisição');
                break;
        }
    }
// TODO END PROPOSTA

// TODO BEGIN CARRINHO

// TODO BEGIN CARRINHO
    transformResultInCarrinho(data: any[]): ICarrinho[] {
        const carrinho: ICarrinho[] = [];
        if(!data){
            return carrinho;
        }
        for (let i = 0; i < data.length; i++) {
            const result = data[i];
            const valoresTitulosDetalhado = result.valoresTitulosDetalhado[0];
            const categoriaTitulo = valoresTitulosDetalhado.categoriaDescricao;
            const codigoCategoria = valoresTitulosDetalhado.codigoCategoria;
            const selectedCategoria = (codigoCategoria.length === 1) ? `0${codigoCategoria}` : codigoCategoria;
            const valorMensal = this.isCupomValido ? this.calcularDesconto(result.valor)  : result.valor;
            const valorMensalString = this.transformMoney(valorMensal);
            carrinho.push({
                id: i,
                titulo: categoriaTitulo.replace('Triplo', ''),
                text1: null,
                text2: null,
                valorMensal,
                valorMensalString,
                categoriaTitulo,
                selectedCategoria,
                countDiarias: result.diarias,
                totalDiarias: null,
                totalValorMensal: null,
                selectedTypeValue: result.pessoas,
                planos: (result.pessoas === 2) ? this.planosDuplos : this.planosTriplos,
                last: false,
            });
        }
        carrinho.forEach( item => {
            if (item.id === carrinho[carrinho.length - 1].id) {
                item.last = true;
            }
        });
        return carrinho;
    }
    zerarBotaoAdicionar() {
        this.carrinhos.forEach( carrinho => carrinho.last = false);
        this.showMaisPlanos = false;
    }
// TODO END CARRINHO

// TODO BEGIN CUPOM
    async validaCupom(hasCustomRule?: boolean, overValueDays?: number) {
        this.appComponent.showOverlay();
        this.isCupomValido = false;
        this.cupomSales = null;
        let result;
        if (this.cupom !== '') {
            result = await this.cupomService.validaSales(this.cupom, this.minDailyCoupon, this.totalDiarias, overValueDays, hasCustomRule);
            if (result) {
                const { data } = result;
                const { totalSize, records, couponMessage } = data;
                this.couponMessage = couponMessage || 'O Cupom Não Existe';
                if (totalSize > 0) {
                    const record = records[0];
                    const { Validade__c, Qntde_desconto__c, Id: id } = record;
                    const validate = new Date(Validade__c);
                    this.isCupomValido = this.isCupomNotExpirate(validate);
                    this.cupomSales = this.isCupomValido ? {
                        cupom: this.cupom,
                        validate,
                        valueDiscount: Qntde_desconto__c / 100,
                        id,
                    } : null;
                    this.setCupomStorage(this.cupomSales);
                }
            }
        }
        await this.calcularValoresFacilita();
    }
    isCupomNotExpirate(validate) {
        return new Date(validate) > new Date();
    }
    async limpaCupom() {
        this.isCupomValido = null;
        const proposta = this.propostaStorage;
        proposta.cupom = this.cupom;
        proposta.valorMensalidadeDesconto = this.transformMoney(proposta.valorMensalidade);
        this.addPropostaParaStorage(proposta);
        await this.calcularValoresFacilita();
        this.removeCupomStorage();
    }
// TODO END CUPOM
}
